import { NotificationTypes, SafeAny } from '@/common/types';
import { ScoreSet } from '@/modules/score-set/types';
import { axiosInstance } from '@/common/utils';
import { getScoreSetByStudy } from './get-score-set-by-study';

export const updateScoreSet = async (
  store: SafeAny,
  {
    sleepStudyID,
    payload,
    epochSize
  }: {
    sleepStudyID: string;
    payload: Partial<ScoreSet>;
    epochSize: number;
  }
) => {
  const { rootState, state, commit, dispatch } = store;
  const url = `${rootState.env?.requestUrl.events}/studies/${sleepStudyID}/score-set`;

  state.scoreSetUpdate.isLoading = true;
  state.scoreSetUpdate.error = undefined;

  try {
    const sendPatchRequest = () =>
      axiosInstance.patch<ScoreSet>(url, {
        ...payload
      });

    const response = await sendPatchRequest();

    await getScoreSetByStudy(store, { sleepStudyID });

    if (response.status === 205) {
      await dispatch(
        'epoch/getStudyScoreSetEvents',
        { studyId: sleepStudyID.toString(), epochSize },
        { root: true }
      );
    }

    state.scoreSetUpdate.isLoading = false;

    commit(
      'addNotification',
      {
        i18nTitle: 'successUpdateScoreSet',
        type: NotificationTypes.Success
      },
      { root: true }
    );
  } catch (error: SafeAny) {
    state.scoreSetUpdate.isLoading = false;
    state.scoreSetUpdate.error = error;

    commit(
      'addNotification',
      {
        i18nTitle: 'errorUpdateScoreSet',
        type: NotificationTypes.Error,
        i18nDescription: error.message
      },
      { root: true }
    );
  }
};
